import {handleOptionClick} from "./handleOptionClick";

export 	function updateOptions(options) {
	const chatOptions = document.getElementById('chat-options');

	chatOptions.innerHTML = '';
	options.forEach(option => {
		const button = document.createElement('button');
		button.className = 'chat-option w-full bg-white border-2 border-primary text-primary px-4 py-3 !rounded-button text-left hover:bg-primary hover:text-white transition-colors cursor-pointer lg:px-6 lg:py-4 lg:text-lg';
		button.textContent = option.text;
		button.addEventListener('click', () => handleOptionClick(option.text, option.response));
		chatOptions.appendChild(button);
	});
}
